module.exports = __webpack_public_path__ + "img/pg.68e1ce33.svg";